
<template>
    <section>
        <FormGroupBox title="Destinos">
            <template #append-title>
                <b-button
                    size="sm"
                    v-if="$hasPermission('rates.add')"
                    variant="success"
                    @click="addRatePlan"
                    ><md-icon icon="add"
                /></b-button>
            </template>

            <b-form-row class="mt-3">
                <b-form-group
                    class="col-lg-3"
                    label="Vigencia">
                    <b-form-select 	v-model="filters.vigencyOption" size="sm">
                        <b-form-select-option value="">Mostrar todos</b-form-select-option>
                        <b-form-select-option value='onlyCurrentRates'>Solo vigentes</b-form-select-option>
                        <b-form-select-option value='avoidExpired'>Solo vigentes y futuros</b-form-select-option>
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    class="col-lg-3"
                    label="Palabra Clave">
                    <b-form-input v-model="filters.keyword" 	size="sm"></b-form-input>
                </b-form-group>

                <b-form-group label=".">
                    <b-button @click="loadRatePlans" size="sm">
                        Buscar
                    </b-button>
                </b-form-group>
            </b-form-row>
            <div>
                <b-table
                    responsive
                    :fields="ratePlansColumns"
                    striped
                    hover
                    bordered
                    :items="ratePlans"
                >
                    <template v-slot:cell(percentageDiscount)="row">
                        {{ row.item.percentageDiscount }} %
                    </template>
                    <template v-slot:cell(startDate)="row">
                        <div class="d-flex flex-column"
                            :class="[
                                isValidateDate(row.item.endDate) ? '' : 'text-danger',
                            ]"
                        >
                            <span class="u:text-size-2 text-muted m-0">
                                {{
                                row.item.startDate != null
                                    ? formatDate(row.item.startDate, "DD/MM/YYYY")
                                    : "Pendiente"
                                }}
                            </span>
                        </div>
                    </template>
                    <template v-slot:cell(endDate)="row">
                    <div
                        class="d-flex flex-column"
                        :class="[
                            isValidateDate(row.item.endDate) ? '' : 'text-danger',
                        ]"
                        >
                        <span class="u:text-size-2 text-muted m-0"
                            ><md-icon
                            icon="info"
                            :class="[
                                row.item.endDate == null
                                ? ''
                                : isValidateDate(row.item.endDate)
                                ? 'text-success'
                                : 'text-danger',
                            ]"
                            :content="
                                row.item.endDate == null
                                ? 'Vecimiento no configurado'
                                : isValidateDate(row.item.endDate)
                                ? 'Tarifa activa'
                                : 'Tarifa expirado'
                            "
                            v-tippy="{ arrow: true, arrowType: 'round' }"
                            />
                            {{
                            row.item.endDate != null
                                ? formatDate(row.item.endDate, "DD/MM/YYYY")
                                : "Pendiente"
                            }}
                        </span>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <div class="text-center">
                            <a
                                v-if="row.item.parentRatePlanId <= 0 && $hasPermission('prices.show')"
                                :href="`/rate-plans-edit?id=${row.item.id}`"
                                target="_blank"
                                class="btn btn-sm mr-1 btn-warning"
                            >
                                <md-icon icon="attach_money" />
                            </a>
                            <b-button
                                @click="event => viewRatePlan(row.item.id)"
                                type="button"
                                size="sm"
                                class="mr-1"
                                variant="primary"
                            >
                                <md-icon icon="edit" />
                            </b-button>
                            <b-button
                                @click="
                                    event =>
                                        deleteRatePlan(
                                            row.item,
                                            row.index,
                                            event
                                        )
                                "
                                type="button"
                                v-if="$hasPermission('rates.delete')"
                                size="sm"
                                class="mr-1"
                                variant="danger"
                            >
                                <md-icon icon="delete" />
                            </b-button>
                            <b-dropdown
                                v-if="$hasPermission('rates.expire')"
                                id="dropdown-1"
                                text="Dropdown Button"
                                variant="success"
                                size="sm"
                                class="mr-1"
                                content="Cierre de tarifa"
                                v-tippy="{ arrow: true, arrowType: 'round' }"
                            >
                                <template #button-content
                                ><md-icon icon="price_check" />
                                </template>
                                <b-dropdown-item
                                    @click="showOpcionsDateRate(row.item, 'expire')"
                                    >Config. expiración de tarifa</b-dropdown-item
                                >
                                <b-dropdown-item
                                    @click="
                                    showOpcionsDateRate(row.item, 'expireAndDuplicate')
                                    "
                                >Config. expiración y duplicar tarifa</b-dropdown-item
                                >
                            </b-dropdown>
                        </div>
                    </template>
                </b-table>
            </div>
        </FormGroupBox>
        <RatePlanSingle
            :unableEdit="unableEditRate"
            ref="ratePlanSingle"
            :success-callback="successCallbackRatePlan"
        />
    </section>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import RatePlanSingle from "../../rate-plans/Single";

//import ClosingRateModal from "../../rate-plans/ClosingRateModal.vue";
//import SingleForm from "./SingleForm.vue"
import moment from "moment";
export default {
	props:{
		idSaleChannel:{
			type: [String, Number],
			required: true
		}
	},
	components: {
		FormGroupBox,RatePlanSingle
	},
	data(){
		return{
			loading:false,
			unableEditRate: false,
			ratePlans:[],
			ratePlansColumns: [
				{ key: "id", label: "ID" },
				{ key: "name", label: "Nombre" },
				{ key: "zonedAreaName", label: "Area" },
				{ key: "currency", label: "Moneda" },
				{ key: "heritance", label: "Conf. Herencia" },
				{ key: "percentageDiscount", label: "Descuento" },
				{ key: "rateType", label: "Tipo" },
				{ key: "startDate", label: "F.Inicio", sortable: true },
				{ key: "endDate", label: "F.Vecimiento", sortable: true },
				{ key: "actions", label: "Acciones" }
			],
			filters:{
				vigencyOption:"onlyCurrentRates",
				keyword:""
			}
		}

	},
	mounted(){
        console.log("mounted!!")
		this.loadRatePlans();
	},
	methods:{
        formatDate(date, format) {
			return moment(date).format(format);
		},
		deleteRatePlan(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					this.$root.api
						.delete(`/rate-plans/${item.id}/sales-channel/${this.idSaleChannel}`)
						.then(() => {
							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.loadRatePlans();
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},
		viewRatePlan(id) {
			this.unableEditRate =  !this.$hasPermission("rates.edit")
			this.$refs["ratePlanSingle"].loadModel(id);
		},
		addRatePlan() {
			this.unableEditRate = false;
			this.$refs["ratePlanSingle"].loadModel(-1);
			setTimeout(() => {
				this.$refs["ratePlanSingle"].setSalesChannelId(this.idSaleChannel);
			}, 0);


		},
		loadRatePlans() {
			if (this.idSaleChannel > 0 ) {
				this.$root.api
					.get(`/sales-channels/${this.idSaleChannel}/rate-plans`,{params:{filters:this.filtersClean}})
					.then(res => {
						this.ratePlans = res.data;
					})
					.catch(this.$root.handleRequestError);
			}
		},
        successCallbackRatePlan() {
			this.loadRatePlans();
		},
        showOpcionsDateRate(itemRate, status) {
			let me = this;
			this.$refs["refClosingRate"].show();
			setTimeout(function () {
				me.$refs.refBodyCloseRate.setTypeOfClousure(status);
				me.$refs.refBodyCloseRate.setRate(itemRate);
			}, 200);
		},
        isValidateDate(fecha) {
			//validamos que el campo sea distinto de null
			if (fecha != null) {
				//obtenemos la fecha actual
				let today = moment().format("YYYY-MM-DD h:mm:ss");
				return (
					moment(today).toDate() <= moment(fecha, "YYYY-MM-DD h:mm:ss").toDate()
				);
			}
			return false;
		},
		
	},
	computed: {
		filtersClean(){
			return {
				vigencyOption:this.filters.vigencyOption,
				keyword:this.filters.keyword
			}
		}
    }
}
</script>

<style scoped>
/* lg */
@media screen and (min-width: 1000px) {
	.modal-dialog{
		width: 55%!important;
		max-width: 55%!important;
	}
}
/* md */
@media screen and (min-width: 720px) and (max-width: 899px)  {
	.modal-dialog{
		width: 75%!important;
		max-width: 75%!important;
	}
}
/* sm */
@media screen and (max-width: 719px) {
	.modal-dialog{
		width: 95%!important;
		max-width: 95%!important;
	}
}
</style>
